import styled from 'styled-components'

import { TextAlignProps, textAlign } from '../../../styles'
import { MarginProps, margin } from '../../../styles/margin'

export interface CardProps extends MarginProps, TextAlignProps {}

export const Card = styled('div').withConfig({
  shouldForwardProp: (prop) => !['textAlign', 'mt', 'mb', 'mr', 'ml', 'm'].includes(prop)
})<CardProps>`
  background: ${({ theme }) => theme.colors.background.white};
  padding: 30px;
  box-shadow: 0 1px 1px rgba(11, 31, 66, 0.04), 0 2px 8px rgba(11, 31, 66, 0.1);
  border-radius: 8px;
  color: ${({ theme }) => theme.colors.font.dark};
  ${margin}
  ${textAlign}
`
